var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 680,
    height: 920,
    viewBox: "0 0 680 920",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_680_30212)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 920,
    rx: 30,
    fill: "#4671F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 460,
    r: 100,
    fill: "#F3F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.688 498.508L193.946 470.582L170.387 485.736L163.173 473.163L188.188 460.391L163.173 447.618L170.387 435.045L193.946 450.199L192.688 422.273H207.049L205.791 450.199L229.35 435.045L236.563 447.618L211.549 460.391L236.563 473.163L229.35 485.736L205.791 470.582L207.049 498.508H192.688Z",
    fill: "#474B53"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 440,
    cy: 460,
    r: 100,
    fill: "#F3F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.688 498.508L433.946 470.582L410.387 485.736L403.173 473.163L428.188 460.391L403.173 447.618L410.387 435.045L433.946 450.199L432.688 422.273H447.049L445.791 450.199L469.35 435.045L476.563 447.618L451.549 460.391L476.563 473.163L469.35 485.736L445.791 470.582L447.049 498.508H432.688Z",
    fill: "#474B53"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680,
    cy: 460,
    r: 100,
    fill: "#F3F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.688 498.508L673.946 470.582L650.387 485.736L643.173 473.163L668.188 460.391L643.173 447.618L650.387 435.045L673.946 450.199L672.688 422.273H687.049L685.791 450.199L709.35 435.045L716.563 447.618L691.549 460.391L716.563 473.163L709.35 485.736L685.791 470.582L687.049 498.508H672.688Z",
    fill: "#474B53"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_680_30212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 920,
    rx: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.b2ac839999c611adff4aebcd6d15a30d.svg";
export { ForwardRef as ReactComponent };